import { useEffect, useState } from 'react'
import { HiMiniPlus, HiTrash, HiPencilSquare } from 'react-icons/hi2'
import { DeleteModal } from './DeleteModal'
import { DefinitionModal } from './DefinitionModal'
import { Suggestions } from './Suggestions'
import { Indicator } from './Indicator'

import CareerAPI from '../../API/career/Career.api'

import { salary } from '../../i18n/translatedMessages'

export function EmployeeCareer({ employee, lists, load, loading, setLoading }) {
	const [createdItem, setCreatedItem] = useState(false)
	const [dataItem, setDataItem] = useState(null)
	const [selectedEditItem, setSelectedEditItem] = useState(null)
	const [selectedDeleteItem, setSelectedDeleteItem] = useState(null)

	const edit = async (event, id) => {
		try {
			setLoading(true)

			await CareerAPI.updateCareer(id, event)

			setSelectedEditItem(null)
			load()
		} catch {
			console.error('EDIT')
		}
	}

	const remove = async id => {
		try {
			setLoading(true)
			await CareerAPI.deleteCareer(id)
			setSelectedDeleteItem(null)
			load()
		} catch {
			console.error('REMOVE')
		}
	}

	const handleClick = async event => {
		try {
			setLoading(true)
			const body = {
				employee_id: employee.employee_id,
				level_id: event.level_id,
				area_id: event.area_id,
				subarea_id: event.subarea_id,
				chosen_by: 'hr',
			}

			await CareerAPI.createCareer(body)
			load()
		} catch {
			console.error('CREATE')
		}
	}

	const dataSet = event => {
		setDataItem(previous => (previous = event))
		setCreatedItem(true)
	}

	return (
		<div>
			<div className='tw-my-2'>
				<h4 className='tw-font-bold tw-text-xl'>{salary.carrerIndicatorsNextStep}</h4>
				<p>{salary.carrerIndicatorsSubtitle}</p>
			</div>

			<div className='tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-8'>
				<div className='tw-flex tw-flex-col tw-w-full'>
					<div className='tw-flex tw-justify-between tw-mb-1'>
						<span className='tw-font-bold tw-py-2'>{salary.carrerIndicatorsManagersChoice}</span>
						{employee.next_steps_hr.length > 0 && (
							<button
								onClick={() => setCreatedItem(true)}
								className='tw-bg-transparent border-0 tw-text-purple tw-flex tw-gap-1 tw-items-center tw-p-2 tw-rounded-md hover:tw-bg-gray-100 active:tw-bg-gray-200/75 '
							>
								<HiMiniPlus />
								<span>{salary.carrerIndicatorsBtnAddNextStep}</span>
							</button>
						)}
					</div>
					{loading ? (
						<div className='tw-w-full border tw-rounded-md tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center tw-min-h-[310px]'>
							{loading && <span className='tw-animate-pulse'>Carregando...</span>}
						</div>
					) : employee.next_steps_hr.length === 0 && !loading ? (
						<div className='tw-w-full border tw-rounded-md tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center tw-min-h-[310px]'>
							<>
								<span className='tw-text-sm tw-text-gray-600 tw-p-2'>{salary.carrerIndicatorsSelectJobSuggested}</span>
								<div className='tw-flex tw-items-center tw-gap-2'>
									<hr className='tw-w-[150px]' style={{ border: '1px solid #64748b' }} />
									<span className='tw-text-gray-400'>{salary.carrerIndicatorsOr}</span>
									<hr className='tw-w-[150px]' style={{ border: '1px solid #64748b' }} />
								</div>
								<button
									onClick={() => setCreatedItem(true)}
									className='tw-bg-transparent border-0 tw-text-purple tw-flex tw-gap-1 tw-items-center tw-p-2 tw-rounded-md hover:tw-bg-gray-100 active:tw-bg-gray-200/75 '
								>
									<HiMiniPlus />
									<span>{salary.carrerIndicatorsBtnDefineNextStep}</span>
								</button>
							</>
						</div>
					) : (
						<div className='tw-w-full border tw-rounded-md tw-bg-white tw-p-2 tw-h-full tw-flex tw-flex-col tw-justify-between'>
							<div className='tw-p-2 tw-mt-2 tw-space-y-2 tw-h-[250px] tw-overflow-auto'>
								{employee.next_steps_hr.map((item, index) => (
									<div key={index} className='tw-flex tw-items-center tw-justify-between'>
										<div className='tw-flex tw-items-center tw-gap-1'>
											<Indicator up={item.level.id > employee.level.id} className='tw-bg-[#E2E4FD] tw-text-[#6C4FDB]' />
											<span>{item.level.value}</span>
											<span className='tw-text-gray-500'>{item?.subarea?.value}</span>
										</div>
										<div className='tw-flex tw-gap-2'>
											<button
												onClick={() => setSelectedEditItem(item)}
												className='tw-h-[32px] tw-w-[32px] tw-rounded-full tw-flex tw-items-center tw-justify-center border-0 tw-text-gray-600 tw-bg-gray-100 hover:tw-bg-gray-200 active:tw-bg-gray-300'
											>
												<HiPencilSquare />
											</button>

											<button
												onClick={() => setSelectedDeleteItem(item)}
												className='tw-h-[32px] tw-w-[32px] tw-rounded-full tw-flex tw-items-center tw-justify-center border-0 tw-text-error-600 tw-bg-error-100 hover:tw-bg-error-200 active:tw-bg-error-300'
											>
												<HiTrash />
											</button>
											{selectedDeleteItem === item && (
												<DeleteModal item={item} onClick={remove} close={() => setSelectedDeleteItem(null)} show={selectedDeleteItem === item} />
											)}
											{selectedEditItem === item && (
												<DefinitionModal
													item={item}
													onClick={edit}
													close={() => setSelectedEditItem(null)}
													lists={lists}
													show={selectedEditItem === item}
													id={item.id}
												/>
											)}
										</div>
									</div>
								))}
							</div>
							<div className='tw-font-bold tw-text-gray-500 tw-text-sm tw-mt-2'>
								{salary.carrerIndicatorsShow} {employee.next_steps_hr.length} {salary.carrerIndicatorsResult}
							</div>
						</div>
					)}
				</div>

				<div className='tw-flex tw-flex-col tw-w-full'>
					<div className='tw-flex tw-gap-2 tw-py-2'>
						<span className='tw-font-bold'>{salary.carrerIndicatorsSuggestion}</span>
						<span className='tw-text-gray-500'>{salary.carrerIndicatorsDescription}</span>
					</div>
					<Suggestions
						onClick={dataSet}
						algorithm={employee.next_steps_algorithm}
						employee={employee.next_steps_employee}
						level={employee.level.id}
					/>
				</div>
			</div>
			<DefinitionModal onClick={handleClick} close={() => setCreatedItem(false)} lists={lists} show={createdItem} item={dataItem} />
		</div>
	)
}
